export class RoleEdit {
  id: number;
  name: string;
  isChecked: boolean;
}
